export default __webpack_public_path__ + "static/media/crt1.bb6ba4ea.jpg";